import { api } from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout(packageId) {
  try {
    const { data } = await api.post("/payments/checkout", {
      package_id: packageId,
      origin_url: window.location.origin,
    });
    window.location.href = data.url;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Could not start checkout");
  }
}

export async function startSubscription() {
  try {
    const { data } = await api.post("/subscription/checkout", {
      package_id: "landlord_unlimited",
      origin_url: window.location.origin,
    });
    window.location.href = data.url;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Could not start subscription");
  }
}
